module.exports = {
  cant_delete: 'Нельзя удалить, данный словарь используется в другом словаре',
  warning: 'Предупреждение',
  remove_all: 'Стереть все',
  dict_confirm_delete:
    'Удаление словаря повлияет на работу метрик, в которых он используется. Вы действительно хотите удалить данный словарь?',
  dictionaries: 'Словари',
  dictionary: 'Словарь',
  popup_hints: {
    to_dictionary: 'Перейти в словарь',
    delete_button: 'Удалить',
    words_count_icon: 'Количество слов/фраз в словаре',
    childs_count_icon: 'Количество словарей, входящих в данный словарь ',
    parents_count_icon: 'Количество словарей, в которых используется данный словарь',
    copy_icon: 'Копировать словарь и дополнить его',
    settings_icon: 'Редактировать словарь',
  },
  table: {
    name: 'НАЗВАНИЕ',
    desc: 'ОПИСАНИЕ',
    params: 'Параметры',
    date: 'Дата обновления',
    actions: 'Действия',
  },
  add_dictionaries: 'Добавить словарь',
  copy: 'копия',
  dict_desc: 'Описание словаря',
  input: 'Ввод',
  date_update: 'Дата обновления',
  dict_used: 'Словарь используется',
  save: 'Сохранить',
  cancel: 'Отменить',
  copy_dict: 'Скопировать словарь',
  delete: 'Удалить',
  dictDeleteToastError:
    'Для удаления словаря необходимо исключить его из всех метрик аналитических проектов',
  fillAllFields: 'Заполните все поля',
  actions: 'Действия',
  download_dictionaries: 'Экспорт словарей',
  import_dictionaries: 'Импорт словарей',
  choose_dictionaries_for_export: 'Выберите словари для скачивания',
  download: 'Скачать',
  choose_dictionaries_for_import: ' Выберите файл для импорта',
  import_selected_file: 'Импортировать выбранный файл',
  success_import: 'Файлы успешно загружены',
  err_import: 'Ошибка загрузки файлов (Возможно присутствует словарь с таким же именем)',
};
